import React, { useEffect, useState } from "react";
import {
  Image,
  Pressable,
  ScrollView,
  StyleSheet,
  Text,
  View,
} from "react-native";
import { connect } from "react-redux";
import { addCartItem } from "../../actions/cart";
import { fetchApi } from "../../api";
import { STYLES } from "../../assets/styles";
import { SCREEN_HEIGHT } from "../../common";
import Container from "../../components/Container";
import CustomButton from "../../components/CustomButton";
import Header from "../../components/Header";
import Like from "../../components/Like";
import Loading from "../../components/Loading";
import Price from "../../components/Price";
import Swiper from "../../components/Swiper";

function PreviewItem({
  navigation,
  route,
  cartItems = {},
  addCartItem,
  loginData = {},
}) {
  const [data, setData] = useState({});
  const [isReady, setIsReady] = useState(false);
  const [scrollTo, setScrollTo] = useState(0);
  const [slectedStyle, setSelectedStyle] = useState({
    color: 0,
    size: 0,
  });

  useEffect(() => {
    fetchApi({
      path: `/items/${route.params.id}`,
    }).then((res) => {
      if (!res.error) {
        setData(res);
      }
      setIsReady(true);
    });
  }, [route.params.id]);

  const handleAddToCart = ({ images, title, _id, image_url }) => {
    fetchApi({
      path: `/cart`,
      method: "POST",
      body: {
        color: images[slectedStyle.color].color,
        size: images[slectedStyle.color].sizes[slectedStyle.size].name,
        title,
        image_url: images[slectedStyle.color].image_url || image_url,
        item_id: _id,
        count: 1,
      },
    }).then((res) => {
      if (!res.error) addCartItem(res);
    });
  };

  const SwiperItem = ({ data }) => (
    <View style={{ height: "100%", width: "100%" }}>
      <Image
        source={{ uri: data }}
        resizeMode="contain"
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
        }}
      />
    </View>
  );

  const handleColorSelect = (index) => {
    setSelectedStyle({ ...slectedStyle, color: index });
    setScrollTo(index);
  };

  return (
    <Container>
      <Header backButton navigation={navigation} title="Preview" />
      {isReady ? (
        <View style={styles.container}>
          <Swiper
            dataArray={data.images}
            style={{
              height: SCREEN_HEIGHT * 0.5,
              borderBottomLeftRadius: 20,
              borderBottomRightRadius: 20,
              overflow: "hidden",
            }}
            scrollTo={scrollTo}
            renderItem={({ item, index }) => (
              <SwiperItem key={index + "s"} data={item.image_url} />
            )}
          />
          <Like
            data={data}
            navigation={navigation}
            style={{
              fontSize: STYLES.fontSizes.large * 1.2,
              right: 20,
              top: SCREEN_HEIGHT * 0.5 - STYLES.fontSizes.large * 1.2 - 25,
              elevation: 1,
            }}
          />
          <ScrollView showsVerticalScrollIndicator={false}>
            <View style={styles.content}>
              <Text style={styles.title}>{data.title}</Text>
              <Price
                style={{
                  flexDirection: "column-reverse",
                }}
                mrp={data.mrp}
                price={data.price}
                discount={data.discount}
              />
              <View style={{ flexDirection: "row", flex: 1 }}>
                <View style={styles.content}>
                  <Text style={styles.txt}>Color</Text>
                  <View style={styles.selectItemContainer}>
                    {data.images.map(({ color }, index) => (
                      <Pressable
                        key={index + "c"}
                        onPress={() => handleColorSelect(index)}
                      >
                        <View
                          style={[
                            styles.colorItem,
                            STYLES.shadow,
                            {
                              backgroundColor: color,
                              borderWidth: index === slectedStyle.color ? 1 : 0,
                            },
                          ]}
                        />
                      </Pressable>
                    ))}
                  </View>
                </View>
                <View style={styles.content}>
                  <Text style={styles.txt}>Select Size</Text>
                  <View style={styles.selectItemContainer}>
                    {data.images[slectedStyle.color].sizes.map(
                      ({ name }, index) => (
                        <Pressable
                          key={index + "s"}
                          onPress={() =>
                            setSelectedStyle({ ...slectedStyle, size: index })
                          }
                        >
                          <Text
                            style={[
                              styles.colorItem,
                              STYLES.shadow,
                              {
                                borderWidth: 1,
                                backgroundColor:
                                  index === slectedStyle.size
                                    ? "#000000"
                                    : "transparent",
                                color:
                                  index === slectedStyle.size
                                    ? "#ffffff"
                                    : "#000000",
                              },
                            ]}
                          >
                            {name}
                          </Text>
                        </Pressable>
                      )
                    )}
                  </View>
                </View>
              </View>
            </View>
          </ScrollView>
          {cartItems[data._id] ? (
            <CustomButton
              leftIcon={{
                type: "Fontisto",
                name: "shopping-bag-1",
              }}
              iconStyle={{ color: "#ffffff" }}
              text="View Cart"
              onPress={() =>
                navigation.navigate("tabs", {
                  screen: "cart",
                  params: { screen: "cartscreen" },
                })
              }
              btnStyle={{
                backgroundColor: STYLES.colors.purpel,
                width: "80%",
                marginTop: 0,
                alignSelf: "center",
              }}
              textStyle={{ color: "#ffffff" }}
            />
          ) : (
            <CustomButton
              leftIcon={{
                type: "Fontisto",
                name: "shopping-bag-1",
              }}
              iconStyle={{ color: "#ffffff" }}
              text="Add To Cart"
              onPress={() => {
                if (loginData.is_guest) {
                  navigation.navigate("tabs", { screen: "favourite" });
                } else {
                  handleAddToCart(data);
                }
              }}
              btnStyle={{
                backgroundColor: "#000000",
                width: "80%",
                marginTop: 0,
                alignSelf: "center",
              }}
              textStyle={{ color: "#ffffff" }}
            />
          )}
        </View>
      ) : (
        <Loading />
      )}
    </Container>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    padding: 10,
  },
  title: {
    width: "90%",
  },
  txt: {
    fontSize: STYLES.fontSizes.small,
  },
  colorItem: {
    minWidth: 28,
    height: 28,
    borderRadius: 14,
    margin: 4,
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: 4,
  },
  selectItemContainer: { flexDirection: "row", flexWrap: "wrap" },
});

const mapStateToProps = (state) => ({
  cartItems: state.cart.itemsIds,
  loginData: state.user.loginData,
});

const mapDispatchToProps = (dispatch) => ({
  addCartItem: (data) => dispatch(addCartItem(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PreviewItem);
